module.exports = {"TRANSFER_ORDERS":"results","TRANSFER_ORDER":{"ID":"id","DESTINATION":"destination","NUMBER":"number","ORDER_DATE_PLACED":"order_date_placed","ORDER_NUMBER":"order_number","PACKAGE":"package","PACKAGE_NUMBER":"package_number","SOURCE":"source","STATE":"state","TARGET_TRANSFER_DATE":"target_transfer_date","TRANSFER_ITEM_SET_PATH":"transferitem_set","TRANSFER_ITEM":{"ID":"id","NAME":"name","PRODUCT_PATH":"product","PRODUCT":{"ID":"id","NAME":"name","SKU":"sku"},"STATE":"state"}}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/transferOrderList.json
// module id = 1754
// module chunks = 1